<template>
	<v-snackbar
		v-model="model"
		:timeout="timeout"
		:multi-line="multiLine"
		text
		color="transparent"
	>
		<!-- <v-badge
			bordered
			overlap
			icon="mdi-close"
			@click.native="model=false"
		>
			<v-alert :type="type">
				<p class="text-h5">{{ title }}</p>
				<p class="text-body-1" v-html="text"></p>
			</v-alert>
		</v-badge> -->
		<v-banner two-line outlined rounded>
			<v-avatar slot="icon" size="60">
				<v-icon v-if="type=='info'" :color="type">mdi-information</v-icon>
				<v-icon v-else-if="type=='success'" :color="type">mdi-check-circle</v-icon>
				<v-icon v-else-if="type=='warning'" :color="type">mdi-alert</v-icon>
				<v-icon v-else-if="type=='error'" :color="type">mdi-alert-circle</v-icon>
				<v-icon v-else :color="type">{{ icon }}</v-icon>
			</v-avatar>

			<h3 class="text-h5">{{ title }}</h3>
			<div v-html="text"></div>

			<template v-slot:actions>
				<v-btn depressed @click="onOk">OK</v-btn>
			</template>
		</v-banner>
    </v-snackbar>
</template>

<script>
import mixin from './mixin/main'
export default {
	mixins: [mixin],
	props: {
		title:  		{ type: String, default: null},
		type:  			{ type: String, default: 'info'}, // info | success | warning | error
		icon:  			{ type: String, default: null},
	},
	methods: {
		onOk() {
			this.$emit('ok')
			this.model=false
		},
	},
}
</script>